import { _mock } from 'src/_mock';

// TO GET THE USER FROM THE AUTHCONTEXT, YOU CAN USE

// CHANGE:
// import { useMockedUser } from 'src/hooks/use-mocked-user';
// const { user } = useMockedUser();

// TO:
// import { useAuthContext } from 'src/auth/hooks';
// const { user } = useAuthContext();

// ----------------------------------------------------------------------

export function useMockedUser() {
  const user = {
    id: '8864c717-587d-472a-929a-8e5f298024da-0',
    displayName: 'Atishay Kumar',
    email: 'atishaykumar@gmail.com',
    password: 'demo1234',
    photoURL: _mock.image.avatar(24),
    phoneNumber: '+91 9999888877',
    country: 'India',
    address: '90, Broadway Blvd',
    state: 'Haryana',
    city: 'Gurugram',
    zipCode: '121001',
    about: 'Praesent turpis. Phasellus viverra nulla ut metus varius laoreet. Phasellus tempus.',
    role: 'admin',
    isPublic: true,
  };

  return { user };
}
